import React from 'react';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import InstructionRepeatOverlay from './InstructionRepeatOverlay';
export default function MmcMediaSection({
  hasVideo,
  hasImage,
  hideMedia,
  videoURL,
  imageURL,
  speech,
  videoPlaying,
  unmountVideoWhenDone,
  suppressVideoReplayOverlay,
  showRepeatOverlay,
  showRepeatOverlayReplay,
  pointerTarget,
  onRepeatOverlayReplay,
  onRepeatOverlayNext,
  onVideoStart,
  onVideoDone,
}) {
  const showsVideo = hasVideo && !hideMedia;
  const showsImage = hasImage && !hasVideo && !hideMedia;

  // The context screen always offers a replay, even when it is narration alone
  // and there is no media to lay the overlay over.
  if (!showsVideo && !showsImage) {
    if (!showRepeatOverlay) return null;
    return (
      <div className="formativeMultipleChoice__media">
        <div className="formativeMultipleChoice__mediaSlot formativeMultipleChoice__audioOnlySlot">
          <InstructionRepeatOverlay
            pointerTarget={pointerTarget}
            showReplay={showRepeatOverlayReplay}
            onReplay={onRepeatOverlayReplay}
            onNext={onRepeatOverlayNext}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="formativeMultipleChoice__media">
      {hasVideo && !hideMedia && (
        <div className="formativeMultipleChoice__mediaSlot">
          <VideoPlayer
            videoURL={videoURL}
            text="Multiple Choice Video"
            unmountWhenDone={unmountVideoWhenDone}
            key="formativeMultipleChoiceVideo"
            speech={speech}
            videoPlaying={videoPlaying}
            maxReplays={0}
            suppressReplayOverlay={suppressVideoReplayOverlay}
            onStart={onVideoStart}
            onDone={onVideoDone}
            useButtonLabels={false}
            useClearButtons={true}
          />
          {showRepeatOverlay && (
            <InstructionRepeatOverlay
              pointerTarget={pointerTarget}
              showReplay={showRepeatOverlayReplay}
              onReplay={onRepeatOverlayReplay}
              onNext={onRepeatOverlayNext}
            />
          )}
        </div>
      )}
      {hasImage && !hasVideo && !hideMedia && (
        <div className="formativeMultipleChoice__staticImage">
          <div className="formativeMultipleChoice__staticImageCell">
            <img src={imageURL} alt="Multiple choice prompt" />
            {showRepeatOverlay && (
              <InstructionRepeatOverlay
                pointerTarget={pointerTarget}
                onReplay={onRepeatOverlayReplay}
                onNext={onRepeatOverlayNext}
                showReplay={showRepeatOverlayReplay}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
